import { GET_NEWS, UPDATE_TEXT_FROM_NEWS } from '../actions/news.action'

const initialState = { list: [] }

export default function newsReducer(state = initialState, action) {
	let news_list = null
	let news = null
	let newsId = null

	switch (action.type) {
		case GET_NEWS:
			news_list = action.payload
			return {
				...state,
				list: [...news_list],
			}
		case UPDATE_TEXT_FROM_NEWS:
			newsId = action.payload.newsId
			news = state.list[newsId]
			news[action.payload.textName] = action.payload.text
			return {
				...state,
				list: updateById(state.list, news),
			}
		default:
			return { ...state }
	}
}

function updateById(newsList, updatedNews) {
	return newsList.map((news) => {
		if (updatedNews.id === news.id) {
			return { ...updatedNews }
		} else {
			return news
		}
	})
}
